import Axios from "@/plugins/Axios";

export class PresencasService {
  async getPresencasNotifiqHikvision(dateOrPayload, horario_id = null, turma_id = null) {
    const payload =
      typeof dateOrPayload === "object"
        ? dateOrPayload
        : { date: dateOrPayload, horario_id, turma_id };

    if (!payload.date || !payload.horario_id || !payload.turma_id) {
      throw new Error("Parâmetros insuficientes: date, horario_id e turma_id são necessários.");
    }

    const response = await Axios().post("notifiq/presencas/get-presencas-hikvision", payload, {
      timeout: 15000,
    });

    return response.data;
  }
}

export default new PresencasService();
